import React from 'react';
import { Box, Text, SimpleGrid, VStack, Image } from '@chakra-ui/react';
interface CollectionCardProps {
  title: string;
  imageUrl: string;
  alt: string;
}
function CollectionCard({
  title,
  imageUrl,
  alt
}: CollectionCardProps) {
  return <Box className="collection-card" role="group" data-id="element-34">
      <Box className="card-image-border" borderRadius="12px" overflow="hidden" border="2px solid transparent" transition="border-color 0.3s ease" _groupHover={{
      borderColor: '#F4B8C1'
    }} aspectRatio="3/4" bg="#F0F0F0" position="relative" data-id="element-35">
        <Image src={imageUrl} alt={alt} w="100%" h="100%" objectFit="cover" fallback={<Box w="100%" h="100%" bg="linear-gradient(135deg, #FAE0E4 0%, #F5EDE0 100%)" display="flex" alignItems="center" justifyContent="center" data-id="element-37">
              <Text className="font-script" fontSize="28px" color="#C9929D" opacity={0.6} data-id="element-38">
                {title}
              </Text>
            </Box>} data-id="element-36" />
      </Box>
      <Text className="font-serif" fontSize={{
      base: '18px',
      md: '20px'
    }} fontWeight={600} color="#3A3A3A" textAlign="center" mt={4} letterSpacing="0.02em" data-id="element-39">
        {title}
      </Text>
    </Box>;
}
export function CollectionCategories() {
  return <Box as="section" bg="white" py={{
    base: 16,
    md: 20
  }} px={{
    base: 6,
    md: 12,
    lg: 20
  }} data-id="element-40">
      <VStack spacing={12} maxW="1200px" mx="auto" data-id="element-41">
        {/* Section title */}
        <VStack spacing={3} textAlign="center" data-id="element-42">
          <Text className="font-script" fontSize={{
          base: '20px',
          md: '24px'
        }} color="#C9929D" data-id="element-43">
            curated for you
          </Text>
          <Text as="h2" className="font-serif" fontSize={{
          base: '28px',
          md: '36px'
        }} fontWeight={700} color="#3A3A3A" data-id="element-44">
            Shop by Collection
          </Text>
          <Box w="60px" h="2px" bg="#F4B8C1" borderRadius="full" data-id="element-45" />
        </VStack>

        {/* 3-column grid */}
        <SimpleGrid columns={{
        base: 1,
        md: 3
      }} spacing={{
        base: 8,
        md: 6,
        lg: 8
      }} w="100%" data-id="element-46">
          <CollectionCard title="Style Bundles" imageUrl="https://cdn.magicpatterns.com/uploads/qcZufQZZVwHxX6aTno3s6p/polina-kuzovkova-pt3EBzQcxP0-unsplash.jpg" alt="Curated outfit style bundles" data-id="element-47" />
          <CollectionCard title="Summer Drop" imageUrl="https://cdn.magicpatterns.com/uploads/8JHksMxAnDRSVjhdMR3Mqm/tyler-davis-O8lxsc1RwCQ-unsplash.jpg" alt="Colorful summer clothing rack" data-id="element-48" />
          <CollectionCard title="Cool Cowgirl" imageUrl="https://cdn.magicpatterns.com/uploads/5TZGYywDou2vy8fingT54Y/omar-lopez-buA5_3PDBXw-unsplash.jpg" alt="Denim and western-inspired looks" data-id="element-49" />
        </SimpleGrid>
      </VStack>
    </Box>;
}